import loginCallbackState from './loginCallback.state'
import homeState from './home.state'
import databasesState from './databases.state'
import jobsState from './jobs.state'
import {ReactStateDeclaration} from '@uirouter/react'
import jobRequestState from './jobRequests.state'
import diagnosticsState from './diagnostics.state'

export default [
  loginCallbackState,
  homeState,
  databasesState,
  jobsState,
  jobRequestState,
  diagnosticsState,
] as ReactStateDeclaration[]
